<!-- This File shows the Parent details for a Seller -->
<template>
  <div class="">
      <!-- Parent -->

      <br />
      <v-card>
       <v-card-title primary-title>
           <div>
             Your parent (<b>{{parentEmail}}</b>) has full access to your account.
           </div>
       </v-card-title>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="showUpdateParent = !showUpdateParent"  flat color="accent">
           Can I change this?
           <v-icon class="ml-1">{{showUpdateParent ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>
          </v-btn>
       </v-card-actions>

       <v-slide-y-transition>
         <v-card-text v-show="showUpdateParent">
           No. After you add a parent, only the parent can remove themselves.
           If you want this to be done, ask your parent to login
           to their account and remove this child account.
         </v-card-text>
       </v-slide-y-transition>
      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'

export default {
  name: 'ParentCard',
  components: {
  },
  computed: {
    ...mapState({
      parentEmail: state => state.admin.parentEmail // If present
    })

  },
  props: {

  },
  data () {
    return {
      showUpdateParent: false,
      inprogress: false,
      errMessage: null
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
